$(function(){
  refreshCheckoutBtn();
  cartJSEvent();
  jscUpdateShippingAndGWPbar();

  if (location.href.includes('/products')) {
    onloadSiblingsProducts();
    onloadPDPbutton();
  }
  
});

refreshCheckoutBtn = () => {

  var myInterval = setInterval( function(){
    if ($('.cart__checkout.btn--loading').length > 0) {
      // console.log('refresh checkout btn');
      $('.cart__checkout.btn--loading').removeClass('btn--loading').removeClass('aiod_checkout_clicked').addClass('aiod_cart_loaded').removeAttr('disabled');
      // clearInterval(myInterval);
    }
    $('.cart__checkout').addClass('aiod_cart_loaded');
  } , 5000);
}

$('.jsc-load-more-btn').on('click', function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.grid--collection').append($(responseHTML).find('.grid--collection').html());
    },
    complete: function() {
      if(currentPage <= totalPages) {
        $this.attr('disabled', false); 
        $this.find('.jsc-load-more-btn').addClass('d-none');
      } 
    }
  })
});

$('.jsc-color-swatch-container').each(function(index, element){
  $(element).children().each(function(index, element) {
    if(index > 3) {
      $(element).hide()
    }
  })
  $('.jsc-extra-color').show();
})

jscHoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--previous').removeClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--next').removeClass('d-none');
  }
}
jscOuthoverGrid = (e) => {
  if ($(window).width() > 799) {
    $(e).find('.jsc-grid-size-container').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--previous').addClass('d-none');
    $(e).find('.jsc-grid-nextprevious-arrows .jsc-image-page-button--next').addClass('d-none');
  }
}

jscMobileGridLayout = (e,grid) => {
  
  var grid_width;
  var price_flex;
  if (grid == 'layout-switch--one-column') {
    grid_width = '100%';
    price_flex = 'row';
  }
  else if (grid == 'layout-switch--two-columns') {
    grid_width = '50%';
    price_flex = 'row';
  } else {
    grid_width = '33%';
    price_flex = 'column';
  }
  console.log(grid,grid_width);
  $(e).addClass('layout-switch--active');
  $(e).siblings('.layout-switch').removeClass('layout-switch--active');
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids .grid__item').css({
    'width' : grid_width 
  });
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids').css({
    'display' : 'flex' ,
    'flex-wrap': 'wrap'
  });
  $(e).parents('.jsc-searchspring').find('.jsc-collection-grids .grid__item .jsc-product-price-grid').css({
    'flex-direction' : price_flex
  });

  // reinitImageSliderGrid();
  
}

//start:pdp color siblings
onloadSiblingsProducts = () => {
  var $prod_details = $('.jsc-prod-json-details').find('.jsc-each-prod-json');
  var $prod_sibs_container = $('.jsc-sibling-products-content');
  var $prod_sibs_grid = $prod_sibs_container.find('.jsc-each-colour-url');
  var $current_url = window.location.href;
  var $swatch_style = $('.jsc-sibling-products-div').attr('data-style');
  console.log($swatch_style);

  $prod_details.each(function(){
    var $this_graphql = $(this).attr('data-graphql');
    // console.log($this_graphql);

        // Define your GraphQL query

        const graphqlQuery = `
        query {
          product(id: "` + $this_graphql + `") {
            id
            title
            handle
            variants(first: 10) {
              edges {
                node {
                  title
                }
              }
            }
            featuredImage {
              id
              src
            }
            swatchHex: metafield(key: "swatch_hex", namespace: "product_data") {
              value
            }
            swatchSvgGID: metafield(key: "swatch_svg", namespace: "product_data") {
              value
              reference {
                ... on MediaImage {
                  image {
                    originalSrc
                  }
                }
              }
            }
            

          }
        }
        `;
        
        // Set the endpoint URL
        const endpointUrl = 'https://all-about-eve-clothing.myshopify.com/api/2023-10/graphql.json';

        // Send the GraphQL request using jQuery
        $.ajax({
          url: endpointUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': '766beaae8d37fc798fc2fd098bb4a3b5', 
          },
          data: JSON.stringify({ query: graphqlQuery }),
          success: function(response) {
            // Handle the response here
            // console.log('Result',response);
            var prod_title = response.data.product.title;
            var prod_handle = response.data.product.handle;
            var prod_img = response.data.product.featuredImage.src;

            //START: color swatch using hex code/svg
            var prod_hex = response.data.product.swatchHex;
            var prod_svg = response.data.product.swatchSvgGID;
            //END: color swatch using hex code/svg
            
            // var prod_url = 'https://www.foxwoodclothing.com.au/products/' + prod_handle;
            var prod_url = '/products/' + prod_handle;
            var variant_title = response.data.product.variants.edges[0].node.title;
            var variant_color = variant_title.split(" / ");
            var type_tab;
            var var_color = '';

            if (variant_color[0] !== undefined ) {
              var_color = variant_color[0];
            } else {
              var_color = '';
            }
            var color_handle = var_color.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

            if ($current_url.includes(color_handle) && var_color != '') {
              // console.log('active',color_handle);
              type_tab = 'jsc-active-col';
            } else {
              // console.log('inactive',color_handle);
              type_tab = 'jsc-inactive-col';
            }
            // console.log(prod_hex);
            
            var $color_grid = '<a href="' + prod_url + '" class="jsc-each-colour-url"><div class="jsc-each-colour-prod ' + type_tab + '"><img class="jsc-each-colour-prod-img" src="' + prod_img + '" alt="' + prod_title +'"></div><span>' + var_color + '</span></a>';
            // console.log($color_grid);
            // $prod_sibs_container.append($color_grid);

            $prod_sibs_grid.each(function(){
              var $thisGraphql = $(this).attr('data-graphql');
              var $thisUrl;
              var $thisColor = $(this).find('span');
              var $thisColorImg = $(this).find('.jsc-each-colour-prod-img');  
              var $thisColorSwatch = $(this).find('.jsc-each-color-swatch');           

              if ($thisGraphql == $this_graphql) {
                // console.log($color_grid);
                $thisUrl = $(this).attr("href",prod_url);

                if ($swatch_style == 'color-code-svg' ) {
                  //START: color swatch using hex code/svg
                  if (prod_hex !== null ) {
                    // console.log('use hex');
                    $thisColorSwatch.css({
                      'background': prod_hex.value
                    });
                  } else {
                    // console.log('use svg');
                    var prod_svg_url = prod_svg.reference.image.originalSrc;
                    $thisColorSwatch.css("background-image", "url(" + prod_svg_url + ")");
                  }
                  //END: color swatch using hex code/svg
                } else {
                  
                  $thisColor.text(var_color);
                  $thisColorImg.attr("src",prod_img);
                  $thisColorImg.attr("alt",prod_title);
                }              
                
                $(this).addClass(type_tab);
                $(this).removeClass('d-none');
                
              }
            });
          },
          error: function(error) {
            // Handle any errors here
            console.error('Error!',error);
          }
        });
  });


  
}
//end:pdp color siblings

//start: update pdp ATC button
onloadPDPbutton = () => {
  var $oosBtn = $('.jsc-pdp-atc-btn-container.jsc-oos-button');
  var $oosBtnInner = $('.jsc-pdp-atc-btn-container.jsc-oos-button .btn.add-to-cart');

  if ($oosBtn.length > 0) {

    var timer = setInterval(function() {
      var $wishlistBtn = $('.jsc-pdp-atc-btn-container .swym-button-bar');
      var $klaviyoBtn = $('.jsc-pdp-atc-btn-container .klaviyo-bis-trigger')

      if ($wishlistBtn.length > 0) {
        if ($klaviyoBtn.length > 0 ) {
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
          $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').css({
            'display': 'block'
          });
          // setTimeout(function(){
            $oosBtnInner.css({
              'position': 'absolute',
              'z-index': '-1'
            });
          // },100);
          
          clearInterval(timer);
        }
      }
    })
  }
}
//end: update pdp ATC button

jscSelectVariant = (e,size,var_avail) => {
  var $label = $(e).parents('.variant-wrapper').find('.jsc-pdp-size');
  $label.find('.jsc-selected-variant').text(size);
  // console.log($label,size);

  if (var_avail == 'true') {
    $('.jsc-pdp-atc-btn-container').removeClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container .btn.add-to-cart').css({
      'position': 'relative',
      'z-index': 'auto'
    });
  } else {
    $('.jsc-pdp-atc-btn-container').addClass('jsc-oos-button');
    $('.jsc-pdp-atc-btn-container.jsc-oos-button .btn.add-to-cart').css({
      'position': 'absolute',
      'z-index': '-1'
    });
    $('.jsc-multiple-var-klaviyo.klaviyo-bis-trigger').removeClass('d-none');
  }
}

//start: custom collection filter
jscCollectionFilter = (e,tabs) => {
  var $thisContent = $(e).siblings('.jsc-filter-content');
  var $otherContent = $(e).parent().siblings('.collection-filter__item').find('.jsc-filter-content');
  
  console.log();

  $thisContent.toggle();

  $otherContent.css('display','none');
  
}
//end: custom collection filter

// start: CartJS Function
cartJSEvent = () => {
  $(document).on('cart.requestComplete', function(event, cart) {
    console.log('cart updated');
    if (location.href.includes('/cart')) {
      $('.jsc-page-loading').remove();
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:build"));
    }
  });
  $(document).on('cart.requestStarted', function(event, cart) {
    if (location.href.includes('/cart')) {
      var $html = `<div class="jsc-page-loading">
                  <div class="jsc-spinner-container">
                    <div class="jsc-loading-text">Updating your cart...</div>
                  </div>
                </div>`;
      $('body').prepend($html);
    }
    console.log('updating cart');
  });
}

cartJSAddQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.addItem(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}

cartJSUpdateQuery = (vid, qty, obj) => {
  // Cart js add item, success callback, error callback

  CartJS.updateItemById(vid, qty, obj,
  {
    // Define a success callback to display a success message.
    "success": function(data, textStatus, jqXHR) {

      if (location.href.includes('/cart')) {
        //reload only the product details section in cart page
        //console.log('data.item_count',data.item_count);
        
        if (!data.item_count) { // if cart is empty do this
          $(".jsc-cart-container").load(location.href+" .jsc-cart-container>*","");
          // console.log('reload empty cart section');
        }
      }
    },
    // Define an error callback to display an error message.
    "error": function(jqXHR, textStatus, errorThrown) {
      console.log("Error occur !", errorThrown);
    }
  });
}
// end: CartJS Function

// start: GWP based on cart, product or collection promo
cartGift = () =>{
  renderCartGift().then(() => {
    addCartGift();
    removeCartGift();
  });
}

addCartGift = () =>{
  var $elem = $('.jsc-cart-gift');
  $elem.each(function() {
    var $vid = parseInt($(this).val());
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
      cartJSAddQuery($vid, 1, $obj);
    }
  });
}

removeCartGift = () =>{
  var $elem = $('.jsc-cart-gift-remove');
  $elem.each(function() {
    var $key = parseInt($(this).val());

    if ($elem.length > 0) {
      cartJSUpdateQuery($key, 0, {});
    }
  });
}

renderCartGift = () => {
  if (!location.href.includes('/cart')) {
    return fetch(window.location.pathname + "?section_id=header")
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartGift = doc.getElementById('jsc-cart-gift');

      if (cartGift) {
        document.getElementById('jsc-cart-gift').innerHTML = cartGift.innerHTML;
      }
    });
  } else {
    return fetch(window.location.pathname + "?section_id=main-cart")
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const cartGift = doc.getElementById('jsc-cart-gift');

      if (cartGift) {
        document.getElementById('jsc-cart-gift').innerHTML = cartGift.innerHTML;
      }
    });
  }
}
// end: GWP based on cart, product or collection promo

// start: free shipping delivery
function calculateProgress(currentVal, targetVal) {
  var freeDeliverySection = $('.jsc-cart-freedelivery__wrapper')
  var cartMinText = freeDeliverySection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = $('.cart-shippingThreshold__progress');
  var progressNum = $('.cart-shipping__num');
  var progressOuter = $('.cart-shipping__numOuter');
  var successMsg = $('.cart-shipping__success');

  $.when($.getJSON('/cart.js', function(cart) {
    var _totalPrice = cart.total_price;
    
    if (_totalPrice > 0) {
      $('.jsc-cart-freedelivery__wrapper').removeClass('d-none');
      var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
      var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
      if (progressWidth >= 100) {
        progressWidth = 100;
      }
      var progressWidthPercent = progressWidth.toString() + '%';
      // console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

      progressBar.each(function(){
        
        $(this).css({
          width: progressWidthPercent
        });
      });

      if (_totalPrice >= cartMinVal) {
        // console.log('free delivery');
        progressOuter.hide();
        successMsg.show();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      } else {
        // console.log('still short from free delivery',calcFreeDeliveryVal);
        progressNum.text(calcFreeDeliveryVal);
        progressOuter.show();
        successMsg.hide();
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      }
    }
    else{
      // console.log('cart Total',_totalPrice);
      $('.jsc-cart-freedelivery__wrapper').addClass('d-none');
    }
    
  })).then(function() {
    
  });

};
// end: free shipping delivery

//start: calculate free gift GWP progress bar
calculateProgressGWP = (currentVal, targetVal) => {
  var freeGiftSection = $('.jsc-cart-freegift-section');
  var cartMinText = freeGiftSection.find('.cart-shipping__wrapper').attr('minprice-aud');
  var cartMinVal = parseInt(cartMinText);
  var progressBar = freeGiftSection.find('.cart-shippingThreshold__progress');
  var progressNum = freeGiftSection.find('.cart-shipping__num');
  var progressOuter = freeGiftSection.find('.cart-shipping__numOuter');
  var successMsg = freeGiftSection.find('.cart-shipping__success');
  var freeItemId = freeGiftSection.find('.cart-shipping__wrapper').attr('data-item-id');
  var isGwpInCart = false;

  if (freeGiftSection.length > 0) {
    $.when($.getJSON('/cart.js', function(cart) {
      var _totalPrice = cart.total_price;
      var $cartItems = cart.items;

      for (var i = 0; i < $cartItems.length; i++) {
        var $itemID = $cartItems[i].id;
        var $itemGwpProp = $cartItems[i].properties['_Cart_GWP'];
        var $itemGwpPropPromo = $cartItems[i].properties['_Cart_Gift'];

        if (freeItemId == $itemID && $itemGwpProp == 'Free Gift' && $itemGwpPropPromo == 1) {
          isGwpInCart = true;
        }
      }
      console.log('isGwpInCart',isGwpInCart);
      
      if (_totalPrice > 0) {
        freeGiftSection.removeClass('d-none');
        var calcFreeDeliveryVal = (cartMinVal - _totalPrice) / 100;
        var progressWidth = Math.round(100 * _totalPrice / cartMinVal);
        if (progressWidth >= 100) {
          progressWidth = 100;
        }
        var progressWidthPercent = progressWidth.toString() + '%';
        //console.log('cart Total',_totalPrice,cartMinVal,progressWidth,progressWidthPercent);

        progressBar.each(function() {
          $(this).css({
            width: progressWidthPercent
          });
        });

        if (_totalPrice >= cartMinVal) {
          // console.log('free gift');
          progressOuter.hide();
          successMsg.show();
          if (isGwpInCart == false) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift" data-promo="1">');
            // cartGift();
          } else {
            $('.jsc-cart-items-section .jsc-cart-gift').remove();
          }
          
        } else {
          // console.log('still short from free gift',calcFreeDeliveryVal);
          progressNum.text(calcFreeDeliveryVal);
          progressOuter.show();
          successMsg.hide();
          if (isGwpInCart == true) {
            $('.jsc-cart-items-section').append('<input type="hidden" value="'+ freeItemId +'" class="jsc-cart-gift-remove jsc-promo-1">');
            //isGwpInCart = false;
            // cartGift();
          }
        }
      }
      else{
        //console.log('cart Total',_totalPrice);
        freeGiftSection.addClass('d-none');
      }
      
    })).then(function() {
      cartGift();
    });
  } else {
    cartGift();
  }
};
jscUpdateShippingAndGWPbar = () => {
  setTimeout(function() {
    calculateProgress();
    calculateProgressGWP();
  }, 500);
}
$(document).on('cart:updated ajaxProduct:added', function(event) {
  jscUpdateShippingAndGWPbar();
});
//end: calculate free gift GWP progress bar

// gift card pdp template
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.disclosure = this.querySelector('details');
    this.toggle = this.querySelector('summary');
    this.panel = this.toggle.nextElementSibling;
    this.init();
  }

  init() {
    // Check if the content element has a CSS transition.
    if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
      this.toggle.addEventListener('click', this.handleToggle.bind(this));
      this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    }
  }

  /**
   * Handles 'click' events on the summary element.
   * @param {object} evt - Event object.
   */
  handleToggle(evt) {
    evt.preventDefault();

    if (!this.disclosure.open) {
      this.open();
    } else {
      this.close();
    }
  }

  /**
   * Handles 'transitionend' events on the details element.
   * @param {object} evt - Event object.
   */
  handleTransitionEnd(evt) {
    if (evt.target !== this.panel) return;

    if (this.disclosure.classList.contains('is-closing')) {
      this.disclosure.classList.remove('is-closing');
      this.disclosure.open = false;
    }

    this.panel.removeAttribute('style');
  }

  /**
   * Adds inline 'height' style to the content element, to trigger open transition.
   */
  addContentHeight() {
    this.panel.style.height = `${this.panel.scrollHeight}px`;
  }

  /**
   * Opens the details element.
   */
  open() {
    // Set content 'height' to zero before opening the details element.
    this.panel.style.height = '0';

    // Open the details element
    this.disclosure.open = true;

    // Set content 'height' to its scroll height, to enable CSS transition.
    this.addContentHeight();
  }

  /**
   * Closes the details element.
   */
  close() {
    // Set content height to its scroll height, to enable transition to zero.
    this.addContentHeight();

    // Add class to enable styling of content or toggle icon before or during close transition.
    this.disclosure.classList.add('is-closing');

    // Set content height to zero to trigger the transition.
    // Slight delay required to allow scroll height to be applied before changing to '0'.
    setTimeout(() => {
      this.panel.style.height = '0';
    });
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${ this.dataset.sectionId }`);
    this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
    this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
    this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
    this.dateInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
    this.addEventListener('change', () => this.onChange());
    this.recipientFields = this.querySelector('.recipient-fields');

    this.checkboxInput.addEventListener('change', () => {
      this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none';
    });
  }

  connectedCallback() {
    document.addEventListener('ajaxProduct:error', (event) => {
      const productVariantID = event.target.querySelector('[name="id"]').value;
      if (productVariantID === this.dataset.productVariantId) {
        this.displayErrorMessage(event.detail.errorMessage);
      }
    });

    document.addEventListener('ajaxProduct:added', (event) => {
      const productVariantID = event.target.querySelector('[name="id"]').value;
      if (productVariantID === this.dataset.productVariantId) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    });
  }

  onChange() {
    if (!this.checkboxInput.checked) {
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }

  clearInputFields() {
    this.querySelectorAll('.field__input').forEach(el => el.value = '');
  }

  displayErrorMessage(body) {
    this.clearErrorMessage();
    if (body) {
      return Object.entries(body).forEach(([key, value]) => {
        const inputElement = this[`${key}Input`];
        if (!inputElement) return;

        inputElement.setAttribute('aria-invalid', true);
        inputElement.classList.add('field__input--error');
      });
    }
  }

  clearErrorMessage() {
    this.querySelectorAll('.field__input').forEach(inputElement => {
      inputElement.setAttribute('aria-invalid', false);
      inputElement.removeAttribute('aria-describedby');
      inputElement.classList.remove('field__input--error');
    });
  }
};

customElements.define('recipient-form', RecipientForm);
//end gift card pdp template